import lozad from 'lozad'

document.addEventListener('DOMContentLoaded', () => {
  const observer = lozad('.lozad', { rootMargin: '30px 0px' })
  observer.observe()
})
